import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  Box,
  ScreenReaderOnly,
  TextHeading,
  Icon,
  Link as MuiLink,
} from '@ally/metronome-ui'
import { muiCreditCard } from './CreditCardIcon'
import { List, ListItem } from '../SharedStyles'
import { useHostServices } from '../../../HostServices'
import { CreditCardOfferData } from '../../../api'
import { useCreditCardOfferMutation } from '../../../hooks'
import { addTradeMark } from '../utils'

const StyledMuiLink = styled(MuiLink)`
  display: inline-flex;
  white-space: normal;
`

export const CreditCardTips: React.FC<{
  customerCardOffer: CreditCardOfferData
}> = ({ customerCardOffer }) => {
  const { session } = useHostServices()
  const guid = session.data?.guid
  const accessToken = session.data?.access_token
  const {
    offerId,
    presented,
    productId,
    productType,
  } = customerCardOffer.offerDetails

  const creditCardOfferMutation = useCreditCardOfferMutation()
  const formattedProductType = addTradeMark(productType, 'Mastercard')

  useEffect(() => {
    ;(window as any).allytm.event('customEvent', {
      name: 'cardOffer',
      type: 'userAttribute',
      attr: {
        user: {
          productId,
          offerId,
        },
      },
    })
  }, [])

  useEffect(() => {
    if (!presented && offerId && accessToken) {
      creditCardOfferMutation.mutate({
        accessToken,
        guid,
        offerId,
      })
    }
    // DO NOT add `creditCardOfferMutation` to dependency array,
    // as with every mutation reference will be updated and
    // will result in infinite loop of mutations.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, guid, offerId, presented])

  return (
    <>
      <ScreenReaderOnly>
        <TextHeading tag="h2" size="md">
          Credit Card
        </TextHeading>
      </ScreenReaderOnly>
      <List data-testid="cc-dashboard-tips">
        <ListItem key={0} data-testid="credit-card-item">
          <Icon
            icon={muiCreditCard}
            fill="plum"
            unsupportedCustomWidth={18}
            unsupportedCustomHeight={18}
            ariaHidden
            mt="5px"
            mr="xs"
            data-testid="credit-card-icon"
          />
          <Box flex="1">
            <Box display="inline" mr="xs">
              You&apos;re pre-approved for the {formattedProductType}.
            </Box>
            <StyledMuiLink
              text="Learn More"
              allytmln="creditCardOffer-learnMore"
            >
              <Link to="/cc-apply-landing" />
            </StyledMuiLink>
          </Box>
        </ListItem>
      </List>
    </>
  )
}
